/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { uniqueId } from "lodash";
import { createContext, useContext, useState } from "react";

interface ConfirmationDialogProps {
  type: "Confirmation";
  id: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

type DialogTypes = ConfirmationDialogProps;

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  return (
    <Dialog open={true}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent>{props.message ?? "Are you sure?"}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.onCancel}>
          Cancel
        </Button>
        <Button onClick={props.onConfirm}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

export function DialogProvider(props: { children: React.ReactNode }) {
  const [dialogQueue, setDialogQueue] = useState<DialogTypes[]>([]);
  const dialog = dialogQueue.length >= 1 ? dialogQueue[0] : null;

  const closeDialog = (id: string) => {
    setDialogQueue([...dialogQueue.filter((d) => d.id !== id)]);
  };

  const confirm = async (message?: string): Promise<boolean> => {
    return new Promise((resolve, _reject) => {
      const id = uniqueId();
      const onConfirm = () => {
        resolve(true);
        closeDialog(id);
      };
      const onCancel = () => {
        resolve(false);
        closeDialog(id);
      };
      const newDialog = { type: "Confirmation", id, onConfirm, onCancel, message } as ConfirmationDialogProps;
      setDialogQueue((queue) => [...queue, newDialog]);
    });
    //return new Promise((resolve) => setTimeout(resolve, 5000));
  };

  const context = {
    confirm,
  };

  return (
    <DialogContext.Provider value={context}>
      {dialog?.type === "Confirmation" && <ConfirmationDialog {...dialog} />}
      {props.children}
    </DialogContext.Provider>
  );
}

export interface DialogState {
  confirm: (message?: string) => Promise<boolean>;
}

const initialState: DialogState = {
  confirm: (message?: string) => Promise.resolve(false),
};

export const DialogContext = createContext(initialState);

export const useDialogs = () => {
  return useContext(DialogContext);
};
